export interface DetectedProduct {
  title: string
  editionLabel: string
  priceNumber: number
  priceText: string
  thumbnailUrl: string
}

const FALLBACK_PRODUCTS: DetectedProduct[] = [
  {
    title: 'Pack Despertar',
    editionLabel: 'Physical Book',
    priceNumber: 27,
    priceText: '$27',
    thumbnailUrl: '',
  },
  {
    title: 'Edición Digital',
    editionLabel: 'Digital Edition',
    priceNumber: 17,
    priceText: '$17',
    thumbnailUrl: '',
  },
]

export function scanPageProducts(): DetectedProduct[] {
  const detected: DetectedProduct[] = []

  try {
    // 1. Try JSON-LD structured data
    const scripts = document.querySelectorAll(
      'script[type="application/ld+json"]',
    )
    scripts.forEach((script) => {
      try {
        const data = JSON.parse(script.innerHTML)
        if (data['@type'] === 'Product' || data['@type'] === 'Offer') {
          const price = data.offers?.price || data.price
          if (price) {
            detected.push({
              title: data.name || document.title,
              editionLabel: 'Digital Edition',
              priceNumber: parseFloat(price),
              priceText: `$${price}`,
              thumbnailUrl: data.image || '',
            })
          }
        }
      } catch (e) {
        // Ignore JSON parse errors
      }
    })

    // 2. Scan DOM for price patterns if no JSON-LD found
    if (detected.length === 0) {
      const priceRegex = /\$\s?(\d+(\.\d{2})?)/
      const elements = document.querySelectorAll('p, span, h1, h2, h3, h4, div')
      const scannedPrices = new Set<string>()

      elements.forEach((el) => {
        if (!el.textContent) return
        const match = el.textContent.match(priceRegex)
        if (
          match &&
          !scannedPrices.has(match[0]) &&
          el.textContent.length < 50
        ) {
          scannedPrices.add(match[0])
          const container = el.closest('div, section')
          const img = container?.querySelector('img')

          detected.push({
            title: document.title.split('-')[0].trim() || 'Product',
            editionLabel: 'Digital Edition',
            priceNumber: parseFloat(match[1]),
            priceText: `$${match[1]}`,
            thumbnailUrl: img?.src || '',
          })
        }
      })
    }
  } catch (error) {
    console.warn('Error scanning products:', error)
  }

  if (detected.length > 0) {
    const validDetected = detected.filter(
      (p) => !isNaN(p.priceNumber) && p.priceNumber > 0,
    )
    if (validDetected.length > 0) {
      return validDetected
    }
  }

  return FALLBACK_PRODUCTS
}

export function getRandomProduct(products: DetectedProduct[]): DetectedProduct {
  if (products === FALLBACK_PRODUCTS || products.length === 0) {
    const rand = Math.random()
    if (rand < 0.7) return FALLBACK_PRODUCTS[0] // 70% Pack Despertar
    return FALLBACK_PRODUCTS[1] // 30% Edición Digital
  }

  const randomIndex = Math.floor(Math.random() * products.length)
  return products[randomIndex]
}
